import type { Dimensions, RenderConfig, TransformConfig } from './types';
/**
 * MatrixRenderer class is meant to be used within a Web Worker context,
 * using Comlink to facilitate communication between the main thread and the worker.
 * The MatrixRenderer class manages a matrix of dies, once an instance of MatrixRenderer is created,
 * it is exposed to the main thread using Comlink's `expose` method.
 * This setup is used in the wafer-map component to perform heavy computational duties
 */
export declare class MatrixRenderer {
    values: Float64Array<ArrayBuffer>;
    scaledColumnIndices: Float64Array<ArrayBuffer>;
    scaledRowIndices: Float64Array<ArrayBuffer>;
    columnIndicesPositions: Int32Array<ArrayBuffer>;
    colorIndices: Int32Array<ArrayBuffer>;
    canvas: OffscreenCanvas;
    context: OffscreenCanvasRenderingContext2D;
    private colors;
    private colorValues;
    private readonly outsideRangeDieColor;
    private readonly fontSizeFactor;
    private renderConfig;
    private transformConfig;
    setMatrixData(columnIndices: Int32Array, rowIndices: Int32Array, valuesBuffer: Float64Array): void;
    setRenderConfig(renderConfig: RenderConfig): void;
    setTransformConfig(transformData: TransformConfig): void;
    setCanvas(canvas: OffscreenCanvas): void;
    scaleCanvas(): void;
    setCanvasDimensions(data: Dimensions): void;
    getCanvasDimensions(): Dimensions;
    clearCanvas(): void;
    drawWafer(): void;
    drawText(): void;
    private isDieInGrid;
    private calculateHorizontalScaledIndices;
    private calculateVerticalScaledIndices;
    private findColorIndex;
}
